import React from "react";
import { X, Save } from "lucide-react";

const StandardRequirementModal = ({
  title,
  onClose,
  requirements,
  loading,
  handleSave,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div style={{maxWidth:"70%"}} className="bg-white rounded-lg shadow-xl  w-full mx-4  overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b">
          <h3 className="text-lg font-semibold text-gray-900"> {title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={20} />
          </button>
        </div>

     
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)] flex flex-wrap  gap-2">
         

          {requirements?.length > 0 ? (
            requirements.map((req, index) => (
              <div
                key={index}
                className="px-4 py-2 border rounded text-sm text-gray-800 bg-gray-50"
              >
                {req}
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-sm">No requirements available.</p>
          )}
        </div>

        <div className="flex justify-end items-center border-t h-[100px]">
        <button
            onClick={onClose}
            style={{borderColor:"#0000a0 !important"}}
            className="px-4 py-2 text-gray-600  border  rounded-md  h-[45px] flex mr-4"

          >
            Cancel
          </button>
       
        </div>
      </div>
    </div>
  );
};

export default StandardRequirementModal;
